export enum ESearchType {
  List = 'list',
  Map = 'map',
}
